import React from "react";
import "./style.scss";
import PaymentFailure from "../../../components/Dashboard/PaymentFailure";
const PaymentFailurePage = () => {
  return (
    <div className="payment_failure_page_wrapper">
      <PaymentFailure />
    </div>
  );
};
export default PaymentFailurePage;
